var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Box, Text, useTheme } from "native-base";
import { isWeb } from "@madmedical/utils";
import Icon from "../icons/Icon";
const EvaluationStatuses = (_a) => {
    var { type, count } = _a, rest = __rest(_a, ["type", "count"]);
    const { colors } = useTheme();
    const icons = useMemo(() => ({
        seen: "view",
        evaluation: "task",
        document: "documentAttachment",
        comment: "chat",
    }), []);
    if (!count) {
        return null;
    }
    return (_jsxs(Box, Object.assign({ flex: 1, flexDirection: "row", alignItems: "center" }, rest, { children: [_jsx(Box, Object.assign({ flex: isWeb ? "0 0 5px" : null }, { children: _jsx(Icon, { name: icons[type], size: 20, fill: colors.green[500] }) })), count > 1 && (_jsxs(Text, Object.assign({ lineHeight: 1, color: "gray.500", fontSize: "xs" }, { children: ["(", count, ")"] })))] })));
};
export default EvaluationStatuses;
